import './section.sass';

export { default } from './section';
